import React, { useEffect, useState,useRef } from "react"
import Layout from "../../NewComponent/Layout/Layout";
import SearchBar from "../../NewComponent/SearchBar/SearchBar";
import { Actions } from "../../Action";
import { bindActionCreators } from "redux";
import { useSelector, useDispatch } from "react-redux";
import Grid from "antd/es/card/Grid";
import TabsSaved from "./TabsSaved";
import { getFavouriteData, getTabSearchData } from '../../API/api'
import PaginationComp from "../../NewComponent/Pagination/Pagination";
import { handleError } from "../../utils";
import TabSearch from "../../NewComponent/TabSearch/tabSearch";
import SelectComp from "../../NewComponent/Select/Select";
import { filterDomainsForComponent2 } from "../../utils";
import MultiSelect from "../../NewComponent/MultiSelect/MultiSelect";
import { favouriteSortFilters } from "../../Constants";
import KeyTagDataBox from "../KeyTermPage/KeyTagDataBox";
import { useLocation } from "react-router-dom";


export default function SavedPages() {
	const dispatch = useDispatch()
	const { updateSortFilterFT, IsLoadingFavouritetab, updateFavouriteTabData, updateSharedByTabData, IsLoadingSharedBytab, updatePageNoFavourite, IsLoadingSharedWithtab, updateFavouriteSearchedQuery, updateFavouriteSortFilterValue, updateFavouriteDomainValue, updateSharedBySearchedQuery, updateSharedBySortFilterValue, updateSharedByDomainValue, updatePageNoSharedBy, updateSharedWithTabData, updateSharedWithSearchedQuery, updateSharedWithSortFilterValue, updateSharedWithDomainValue, updatePageNoSharedWith } = bindActionCreators(Actions, dispatch);
	const keyTagState = useSelector(state=>state.keyTag); 
	const recommendState = useSelector((state)=>state.recommend)
	const pageState = useSelector((state) => state.favouriteQuestions);
	const sharedByMeState = useSelector((state) => state.sharedBy)
	const sharedWithMeState = useSelector((state) => state.sharedWith);
	const userState = useSelector((state) => state.user);
	const [tab, setTabValue] = useState(recommendState.tabValue !== undefined && recommendState.tabValue !== null ? recommendState.tabValue : 1);
	const [isTabSearch, setIsTabSearch] = useState(false)
	const [isFirstLoad, setIsFirstLoad] = useState(true);
	const  [options,setOptions] = useState(favouriteSortFilters)
	const [favouriteTabQuery,setFavouriteTabQuery] = useState(pageState.searchQuery)
	const location = useLocation();


	const handleTabValue = (value) => {
		setTabValue(value);
		setIsTabSearch(true)
	};

	const isCheckRelevance = (str) => {
		let isThere = false;
		for (let i = 0; i < str.length; ++i) {
			if (str[i].label === "Relevance") {
				isThere = true;
			}
		}
		return isThere;
	};

	

	const fetchFavouriteData = () => {
		if (pageState.searchQuery.length === 0) {
			IsLoadingFavouritetab(true);
			const status = "getfavourite";
			const category = 1;

			getFavouriteData(
				pageState.pageNo,
				pageState.sortFilter.origValue,
				pageState.sortFilter.sortOrder,
				pageState.sortChange,
				pageState.domains,
				category,
				status
			)
				.then((res) => {
					if (res?.data?.success) {
						IsLoadingFavouritetab(false);
						updateFavouriteTabData({
							data: res.data.data,
							count: res.data.count,
							value: tab,
						});
					}
				})
				.catch(handleError);
		} else if (pageState.searchQuery.length > 0) {
			IsLoadingFavouritetab(true);
			const status = "favorite";
			const category = 1;

			getTabSearchData(
				pageState.pageNo,
				status,
				pageState.sortFilter.origValue,
				pageState.searchQuery,
				pageState.sortFilter.sortOrder,
				false,
				pageState.domains,
				category
			)
				.then((res) => {
					if (res?.data?.success) {
						IsLoadingFavouritetab(false);
						updateFavouriteTabData({
							data: res.data.data,
							count: res.data.count,
							value: tab,
						});
					}
				})
				.catch(handleError);
		}
	}

	const fetchSharedByMeTabData = () => {
		if (sharedByMeState.searchQuery.length === 0) {
			IsLoadingSharedBytab(true);
			const status = "getsharedbyme";
			const category = 2;

			getFavouriteData(
				sharedByMeState.pageNo,
				sharedByMeState.sortFilter.origValue,
				sharedByMeState.sortFilter.sortOrder,
				sharedByMeState.sortChange,
				sharedByMeState.domains,
				category,
				status
			)
				.then((res) => {
					if (res?.data?.success) {
						IsLoadingSharedBytab(false);
						updateSharedByTabData({
							data: res.data.data,
							count: res.data.count,
							value: tab,
						});
					}
				})
				.catch(handleError);
		} else if (sharedByMeState.searchQuery.length > 0) {
			IsLoadingSharedBytab(true);
			const status = "sharedByMe";
			const category = 2;

			getTabSearchData(
				sharedByMeState.pageNo,
				status,
				sharedByMeState.sortFilter.origValue,
				sharedByMeState.searchQuery,
				sharedByMeState.sortFilter.sortOrder,
				false,
				sharedByMeState.domains,
				category
			)
				.then((res) => {
					if (res?.data?.success) {
						IsLoadingSharedBytab(false);
						updateSharedByTabData({
							data: res.data.data,
							count: res.data.count,
							value: tab,
						});
					}
				})
				.catch(handleError);
		}
	};

	const fetchSharedWithMeTabData = () => {
		if (sharedWithMeState.searchQuery.length === 0) {
			IsLoadingSharedWithtab(true);
			const status = "getsharedwithme";
			const category = 2;

			getFavouriteData(
				sharedWithMeState.pageNo,
				sharedWithMeState.sortFilter.origValue,
				sharedWithMeState.sortFilter.sortOrder,
				sharedWithMeState.sortChange,
				sharedWithMeState.domains,
				category,
				status
			)
				.then((res) => {
					if (res?.data?.success) {
						IsLoadingSharedWithtab(false);
						updateSharedWithTabData({
							data: res.data.data,
							count: res.data.count,
							value: tab,
						});
					}
				})
				.catch(handleError);
		} else if (sharedWithMeState.searchQuery.length > 0) {
			IsLoadingSharedWithtab(true);
			const status = "sharedWithMe";
			const category = 2;

			getTabSearchData(
				sharedWithMeState.pageNo,
				status,
				sharedWithMeState.sortFilter.origValue,
				sharedWithMeState.searchQuery,
				sharedWithMeState.sortFilter.sortOrder,
				false,
				sharedWithMeState.domains,
				category
			)
				.then((res) => {
					if (res?.data?.success) {
						IsLoadingSharedWithtab(false);
						updateSharedWithTabData({
							data: res.data.data,
							count: res.data.count,
							value: tab,
						});
					}
				})
				.catch(handleError);
		}
	};

	function getTotalCount(value) {
		if (value === 1) {
			return (
				<>
					<span>Favorite Questions: {pageState.isLoading ? '0' : pageState.totalCount}</span>
				</>
			)
		}
		if (value === 2) {
			return (
				<>
					<span>Shared By Me: {sharedByMeState.isLoading ? '0' : sharedByMeState.totalCount}</span>
				</>
			)
		}
		if (value === 3) {
			return (
				<>
					<span>Shared With Me: {sharedWithMeState.isLoading ? '0' : sharedWithMeState.totalCount}</span>
				</>
			)
		}
	}

	const handlePageChange = (e) => {
		if (tab === 1) {
			updatePageNoFavourite(e - 1)
		}
		if (tab === 2) {
			updatePageNoSharedBy(e - 1)
		}
		if (tab === 3) {
			updatePageNoSharedWith(e - 1)
		}
	}

	const onChangeTabSearch = (e) => {
		if (tab === 1) {
			if(e.target.value.length !== 0 &&!isCheckRelevance(pageState.sortOptions))
			{
				// setIsTabSearch(true)
				let newObj = { id: '3', value: "Relevance", label: "Relevance", origValue: 'relevance', sortOrder: 'asc' }
				let sdf = [...pageState.sortOptions];
				sdf.push(newObj);
				updateSortFilterFT(sdf);
				updateFavouriteSearchedQuery(e.target.value)
				updateFavouriteSortFilterValue(newObj)
				// if(setIsTabSearch)
				// {
				// 	console.log('check')
				// 	updateFavouriteSearchedQuery('')
				// }
			}			
			if (e.target.value.length === 0 ) {
				updateFavouriteSearchedQuery('')
				// setIsTabSearch(false)
				let sdf = [...pageState.sortOptions];
				sdf.pop();
				updateSortFilterFT(sdf);
				if (pageState.sortFilter.label === "Relevance") {
					updateFavouriteSortFilterValue(pageState.sortOptions[0]);
				}
			}
			// if(e.target.value.length !== 0 &&!isCheckRelevance(pageState.sortOptions) && isTabSearch)
			// {
			// 	updateFavouriteSearchedQuery('')
			// }
		}
		if (tab === 2) {
			if(e.target.value.length !== 0 && !isCheckRelevance(sharedWithMeState.sortOptions))
			{
				// setIsTabSearch(true)
				let newObj = { id: '3', value: "Relevance", label: "Relevance", origValue: 'relevance', sortOrder: 'asc' }
				let sdf = [...favouriteSortFilters];
				sdf.push(newObj)
				updateSharedBySearchedQuery(e.target.value)
				updateSharedBySortFilterValue(newObj)	
			}		
			if (e.target.value.length === 0) {
				updateSharedBySearchedQuery('')
				// setIsTabSearch(false)
				if (sharedByMeState.sortFilter.label === "Relevance") {
					updateSharedBySortFilterValue(sharedByMeState.sortOptions[0]);
				}
			}
			if(e.target.value.length !== 0 && isTabSearch && !isCheckRelevance(sharedWithMeState.sortOptions))
			{
				updateSharedBySearchedQuery('')
			}
		}
		if (tab === 3) {
			if (e.target.value.length !== 0 &&!isCheckRelevance(sharedWithMeState.sortOptions)) {
				// setIsTabSearch(true)
				let newObj = { id: '3', value: "Relevance", label: "Relevance", origValue: 'relevance', sortOrder: 'asc' }
				let sdf = [...sharedWithMeState.sortOptions]
				sdf.push(newObj)
				updateSharedWithSearchedQuery(e.target.value)
				updateSharedWithSortFilterValue(newObj)
			}
			if (e.target.value.length === 0 || e.target.value === '') {
				// setIsTabSearch(false)
				updateSharedWithSearchedQuery('')
				if (sharedWithMeState.sortFilter.label === "Relevance") {
					updateSharedWithSortFilterValue(sharedWithMeState.sortOptions[0])
				}
			}
			if(e.target.value.length !== 0 && isTabSearch && !isCheckRelevance(sharedWithMeState.sortOptions))
			{
				updateSharedWithSearchedQuery('')
			}
		}
	}

	const onChangeTabSearchSharedByMe = (e) => {
		if (e.target.value.length !== 0 && !isCheckRelevance(sharedWithMeState.sortOptions)) {
			// setIsTabSearch(true)
			let newObj = { id: '3', value: "Relevance", label: "Relevance", origValue: 'relevance', sortOrder: 'asc' }
			let sdf = [...favouriteSortFilters];
			sdf.push(newObj)
			updateSharedBySearchedQuery(e.target.value)
			updateSharedBySortFilterValue(newObj)
		}
		if (e.target.value.length === 0) {
			updateSharedBySearchedQuery('')
			// setIsTabSearch(false)
			if (sharedByMeState.sortFilter.label === "Relevance") {
				updateSharedBySortFilterValue(sharedByMeState.sortOptions[0]);
			}
		}
	}

	const onChangeTabSearchSharedWithMe = (e) => {
		if (e.target.value.length !== 0 && !isCheckRelevance(sharedWithMeState.sortOptions)) {
			// setIsTabSearch(true)
			let newObj = { id: '3', value: "Relevance", label: "Relevance", origValue: 'relevance', sortOrder: 'asc' }
			let sdf = [...sharedWithMeState.sortOptions]
			sdf.push(newObj)
			updateSharedWithSearchedQuery(e.target.value)
			updateSharedWithSortFilterValue(newObj)
		}
		if (e.target.value.length === 0 || e.target.value === '') {
			// setIsTabSearch(false)
			updateSharedWithSearchedQuery('')
			if (sharedWithMeState.sortFilter.label === "Relevance") {
				updateSharedWithSortFilterValue(sharedWithMeState.sortOptions[0])
			}
		}
	}

	const onChangeSortingOrder = (e) => {
		const modifiedObject = {
			...e,
			id: e === e.value === 'recently asked' ? 1 : 2,
			origValue: 'questionAsked',
			sortOrder: e.value === 'recently asked' ? "desc" : "asc"
		};
		if (tab === 1) {
			updateFavouriteSortFilterValue(modifiedObject)
		}
		if (tab === 2) {
			updateSharedBySortFilterValue(modifiedObject)
		}
		if (tab === 3) {
			updateSharedWithSortFilterValue(modifiedObject)
		}
	}

	const onChangeDomainSelect = (value) => {
		let newVal = value.map((obj, ind) => {
			let newObj = { name: obj, label: obj, value: obj }
			return newObj;
		})
		if (tab === 1) {
			updateFavouriteDomainValue(newVal)
		}
		if (tab === 2) {
			updateSharedByDomainValue(newVal)
		}
		if (tab === 3) {
			updateSharedWithDomainValue(newVal)
		}
	}



	// useEffect(() => {
	// 	searchInputValue('')
	// 	fetchData()
	// }, [pageState.pageNo,pageState.searchQuery,pageState.sortFilter,pageState.sortOrder,pageState.reload,pageState.domains,sharedByMeState.searchQuery,sharedByMeState.sortFilter,sharedByMeState.domains,sharedByMeState.pageNo,sharedWithMeState.searchQuery,sharedWithMeState.sortFilter,sharedWithMeState.pageNo,sharedWithMeState.domains])

	// useEffect(() => {
	// searchInputValue('')
	// 	// if (isFirstLoad) {
	// 	// 	// fetchFavouriteData()
	// 	// 	fetchSharedByMeTabData()
	// 	// 	fetchSharedWithMeTabData()
	// 	// 	setIsFirstLoad(false)
	// 	// }
	// 		fetchFavouriteData()
	// 		fetchSharedByMeTabData()
	// 		fetchSharedWithMeTabData()
		
	// }, [sharedByMeState.searchQuery, sharedByMeState.sortFilter, sharedByMeState.domains, sharedByMeState.pageNo, sharedWithMeState.searchQuery, sharedWithMeState.sortFilter, sharedWithMeState.pageNo, sharedWithMeState.domains])

	useEffect(()=>{
		if(recommendState.isBack === false)
		{
		fetchFavouriteData()}
		const message = location.state?.message;
	},[pageState.pageNo,pageState.searchQuery,pageState.sortFilter,pageState.sortOrder,pageState.reload,pageState.domains])

	useEffect(()=>{
		if(recommendState.isBack === false)
		{
		fetchSharedByMeTabData()}
	},[sharedByMeState.searchQuery,sharedByMeState.sortOrder, sharedByMeState.sortFilter, sharedByMeState.domains, sharedByMeState.pageNo])

	useEffect(()=>{
		if(recommendState.isBack === false)
		{
		fetchSharedWithMeTabData()}
		
	},[sharedWithMeState.searchQuery, sharedWithMeState.sortFilter, sharedWithMeState.pageNo, sharedWithMeState.domains])

	function getTabbedValue(value){
		let query = '';
		if(value === 1)
		{
			query = pageState.searchQuery
			return query;
		}
		if(value === 2)
		{
			query = sharedByMeState.searchQuery
			return query;
		}
		if(value === 3)
		{
			query = sharedWithMeState.searchQuery
			return query;
		}
	}

	return (
		<>
			<Layout>
				<div style={{ width: "74%", margin: "auto", marginTop: "1%", marginBottom: '7%' }}>
					<SearchBar />
					<Grid container style={{ backgroundColor: '#fff', marginTop: '4%', borderRadius: '12px', border: '1px solid #e0e2e6', padding: '24px' }}>
						{!keyTagState.isBack && <>
						<div style={{
							fontSize: '16px',
							fontWeight: 500,
							lineHeight: '24px',
							textAlign: 'left',
							color: '#2A364A',
							width: '100%'
						}}>{getTotalCount(tab)}</div>
						<div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '7px', marginBottom: '15px', width: '100%', flexWrap: 'wrap' }}>
							<div style={{width:'240px'}}>
								{tab === 1 &&<TabSearch val={pageState.searchQuery} size={"large"} onChangeFunc={onChangeTabSearch} />}
								{tab === 2 && <TabSearch val={sharedByMeState.searchQuery} size={"large"} onChangeFunc={onChangeTabSearchSharedByMe} />}
								{tab === 3 && <TabSearch val={sharedWithMeState.searchQuery} size={"large"} onChangeFunc={onChangeTabSearchSharedWithMe}/>}
							</div>
							<div style={{ display: 'flex', alignItems: 'center', gap: '12px', width: '51%', justifyContent: 'end' }}>
								
								<div >
								<SelectComp
									isString={false}
									val={tab === 1 ? pageState.sortFilter.value : tab === 2 ? sharedByMeState.sortFilter.value : tab === 3 ? sharedWithMeState.sortFilter.value : null}
									onChangeFunc={onChangeSortingOrder}
									options={tab === 1 ? pageState.sortOptions : tab === 2 ? sharedByMeState.sortOptions : tab === 3 ? sharedWithMeState.sortOptions : tab === 3 ? sharedWithMeState.sortOptions : null}
									width={"180px"}
									size={"large"}
									labelInValue={true}
									
								/>
								</div>
							
								<MultiSelect size={'large'} width={'45%'} value={tab === 1 ? pageState.domains : tab === 2 ? sharedByMeState.domains : tab === 3 ? sharedWithMeState.domains : null} options={filterDomainsForComponent2(userState.visibleTopics)} onChangeFunc={onChangeDomainSelect} placeholder={'Select Domains'} />
								{/* <MultiSelectOpen /> */}
							</div>
						</div>
						<TabsSaved onStateChange={handleTabValue} />
						<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
							<PaginationComp page={tab === 1 ? pageState.pageNo + 1 : tab === 2 ? sharedByMeState.pageNo + 1 : tab === 3 ? sharedWithMeState.pageNo + 1 : null} total={tab === 1 ? pageState.totalCount : tab === 2 ? sharedByMeState.totalCount : tab === 3 ? sharedWithMeState.totalCount : null} onChangeFunc={(e) => handlePageChange(e)} />
						</div>
						</>}
						{keyTagState.isBack && <KeyTagDataBox />}
					</Grid>
				</div>
			</Layout>
		</>
	)
}